import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useClientV2} from "../../../../utils/hooks";
import {AxiosError} from "axios";
import {message} from "antd";
import {
  GET_STORE_SERVICE_CUSTOMER_ORDER_RQ_KEY,
  GET_STORE_SERVICE_CUSTOMER_ORDERS_RQ_KEY,
} from "../constants";

export const useCustomerStoreServiceOrderRequestRevisionApi = () => {
  const queryClient = useQueryClient();

  const client = useClientV2();
  return useMutation<
    {data: any},
    AxiosError<
      {
        message: string;
      },
      any
    >,
    {orderId: number; reason: string},
    unknown
  >({
    mutationFn: (payload: {orderId: number; reason: string}) =>
      client(`customer/product-services/order/${payload.orderId}/request-revision`, {
        method: "PUT",
        data: {
          reason: payload.reason,
        },
      }),
    onError: (error: AxiosError<{message: string}>) => {
      if (error.message) {
        message.error(error.message);
      }
    },
    onSettled: (d, e, v) =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_STORE_SERVICE_CUSTOMER_ORDERS_RQ_KEY, {statusId: 4, page: 1}],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_STORE_SERVICE_CUSTOMER_ORDER_RQ_KEY, String(v.orderId)],
        }),
      ]),
  });
};
